// Module
var code = "<h2 id=\"beware-of-scams\">Beware of Scams</h2> <p>Protect yourself from &quot;Debt Relief&quot; Organizations.</p> ";
// Exports
export default code;